export default "__VITE_ASSET__77e70495__"